module.exports = __webpack_public_path__ + "img/1495121075.b834f82c.jpg";